import { useGetQuoteQuery } from './studioApi'
import type { ActiveJob } from './studioStartTypes'

export interface ImageQuoteView {
  /** Размер авто-плана — считает СЕРВЕР. Обход блоков по урокам фронту не нужен. */
  autoTargets?: number
  /** Цена всего авто-плана из сметы, не `per_image × autoTargets`. */
  autoCost?: string
  /** Цена ОДНОЙ картинки: ручной режим считает план сам, `auto_cost` тут не годится. */
  perImage?: string
  /** Потолок плана прогона: больше — `422 too_many_image_targets`. */
  maxTargets?: number
  /** Сколько картинок в ОДНОМ наборе пилотов. */
  pilotVariants?: number
  /** Цена всего набора. Прибавлять к `autoCost` только когда автор набор заказал. */
  pilotSetCost?: string
  balance?: string
  activeJob: ActiveJob | null
  isLoading: boolean
  /** Повторная попытка после упавшего `GET /quote`: без сметы запуск погашен
   *  навсегда, а закрыть-открыть диалог ради рефетча автор не догадается. */
  refetch: () => void
}

/**
 * Картиночная часть сметы. Чтение защитное по всей цепочке — тем же стилем,
 * что `useCourseQuote`/`useNewCourseQuote`: два хука на один payload не должны
 * читать его по-разному, а неполный ответ не должен ронять экран.
 *
 * `refetchOnMountOrArgChange`: диалог обязан отражать МОМЕНТ открытия, а не
 * смету, закешированную до того, как автор дописал десяток промптов.
 */
export const useImageQuote = (courseId: number, skip: boolean): ImageQuoteView => {
  const { data, isFetching, refetch } = useGetQuoteQuery(courseId, {
    skip,
    refetchOnMountOrArgChange: true,
  })
  return {
    autoTargets: data?.image_generation?.auto_targets,
    autoCost: data?.image_generation?.auto_cost,
    perImage: data?.image_generation?.per_image,
    maxTargets: data?.image_generation?.max_targets,
    pilotVariants: data?.image_generation?.pilot_variants,
    pilotSetCost: data?.image_generation?.pilot_set_cost,
    balance: data?.balance,
    activeJob: data?.active_job ?? null,
    isLoading: !skip && isFetching,
    refetch: () => void refetch(),
  }
}
